export const CONFACL_DELETE_RESET = 'CONFACL_DELETE_RESET'
export const CONFACL_DELETE_SET_ERROR = 'CONFACL_DELETE_SET_ERROR'
export const CONFACL_DELETE_SET_DELETED = 'CONFACL_DELETE_SET_DELETED'
export const CONFACL_DELETE_TOGGLE_LOADING = 'CONFACL_DELETE_TOGGLE_LOADING'
